import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './section-wrapper.module.scss';

type SectionWrapperProps = {
  disabled?: boolean;
  children: ReactNode;
};

const SectionWrapper = ({ disabled, children }: SectionWrapperProps) => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.disabled!]: disabled
      })}
    >
      {children}
    </div>
  );
};

export default SectionWrapper;
